module.exports = __webpack_public_path__ + "img/game1.917cb5a8.jpg";